import { Button, ConfirmModal } from '../../../../components';
import { useModalToggle } from '../../../../hooks';
import { useFormContext } from 'react-hook-form';
import { useState, useContext } from 'react';
import { Localization } from '../../../../config/localization/localization';
import { LanguageSelectorContext } from '../../../../context/LanguageSelectorContext';

import type { IToggle } from '../../../../hooks';
import type { IFile } from '../../../../types';
import type { FC } from 'react';

interface IUploadedFilesProps {
    files: IFile[];
    isRemoving: IToggle;
    isUploading: IToggle;
    onRemove: (id: number) => void;
}

export const UploadedFiles: FC<IUploadedFilesProps> = ({ files, isRemoving, isUploading, onRemove }) => {
    const [fileToRemove, setFileToRemove] = useState<IFile | null>(null);
    const confirmRemoveToggle = useModalToggle();

    const { selectedLanguage } = useContext(LanguageSelectorContext);
    const localization = new Localization(selectedLanguage);

    const onRemoveClick = (file: IFile) => {
        setFileToRemove(file);
        confirmRemoveToggle.open();
    };

    const onRemoveConfirmed = () => {
        if (fileToRemove === null) return;
        onRemove(fileToRemove.id);
    };

    return (
        <div className={'mt-2 flex flex-col space-y-2.5'}>
            {/* UPLOADED FILES */}
            {files.map((file, index) => {
                return (
                    <div
                        className={'spacing-x-2 items-center font-medium text-gray-800 dark:text-gray-200'}
                        key={index}
                    >
                        <Button
                            busyText={localization.translate('uploadedFiles.removingBusyText')}
                            buttonProps={{
                                isDisabled: isRemoving.isOn || isUploading.isOn,
                                onPress: () => onRemoveClick(file),
                            }}
                            isBusy={file.id === fileToRemove?.id ? isRemoving.isOn : false}
                            size={'xs'}
                            variant={'outline'}
                        >
                            <span className={'text-xs'}>
                                {localization.translate('actions.Remove')}
                            </span>
                        </Button>
                        <span className={'mx-2'}>{file.displayName}</span>
                        <span className={'mr-2'}>{file.note && file.note.length > 0 ? '-' : ''}</span>
                        <span className={'mr-2'}>{file.note}</span>
                    </div>
                );
            })}

            {/* CONFIRM REMOVE FILE */}
            <ConfirmModal
                className={'max-w-lg'}
                message={localization.translate('uploadedFiles.confirmRemoveMessage').replace('{fileName}', fileToRemove?.displayName ?? '')}
                modalToggle={confirmRemoveToggle}
                onConfirm={onRemoveConfirmed}
                title={localization.translate('uploadedFiles.confirmRemoveTitle')}
            />
        </div>
    );
};